export const X = 0;
export const Y = 1;
export type ChartData = number[][];
